import { Switch } from '@optiaxiom/react';

import type { ToolChatToggleProps } from './types';

export function ToolChatToggle({ tool, onToggleEnabledInPrimaryAgent }: ToolChatToggleProps) {
  return (
    <Switch
      disabled={tool.is_disabled}
      checked={tool.is_enabled_in_primary_agent}
      onCheckedChange={checked => onToggleEnabledInPrimaryAgent(tool.name, !checked)}
      aria-label={`Toggle ${tool.name} enabled in primary agent`}
    />
  );
}
